import { render, staticRenderFns } from "./StrategyDetailPage.vue?vue&type=template&id=4bfc3ef6&scoped=true"
import script from "./StrategyDetailPage.vue?vue&type=script&lang=js"
export * from "./StrategyDetailPage.vue?vue&type=script&lang=js"
import style0 from "./StrategyDetailPage.vue?vue&type=style&index=0&id=4bfc3ef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc3ef6",
  null
  
)

export default component.exports